import styled from "styled-components"
import { getCssSizeValue, getHtmlFromRedactorField, isStringEmpty, parseDatoText } from "@/utils/utils"
import GridContainer from "@/components/common/GridContainer"
import Reveal from "@/animations/Reveal"
import PreserveSearchParamsLink from "@/components/common/Links/PreserveSearchParamsLink"
import Icon from "@/components/common/Icon/Icon"
import { ICONS, PAGES } from "@/constants"
import { BREAKPOINTS } from "@/styles/themeSettings"
import React from "react"

const Wrapper = styled.div`
	overflow: hidden;
	position: relative;
	display: flex;
	flex-direction: column;
	padding-top: ${getCssSizeValue(192, BREAKPOINTS.MOBILE)};
	padding-bottom: ${getCssSizeValue(72, BREAKPOINTS.MOBILE)};

	background: ${({ theme }) => theme.colors.white};

	.header {
		margin-bottom: ${getCssSizeValue(56)};
	}

	.description {
		padding-bottom: ${getCssSizeValue(96)};
	}

	@media (min-width: ${({ theme }) => theme.breakpoints.tablet}px) {
	}

	@media (min-width: ${({ theme }) => theme.breakpoints[BREAKPOINTS.DESKTOP]}px) and (orientation: landscape) {
		padding-top: ${getCssSizeValue(260)};
		padding-bottom: ${getCssSizeValue(96)};
	}
`

const StyledGoBackButton = styled(PreserveSearchParamsLink)`
	position: absolute;
	top: ${getCssSizeValue(200)};
	left: var(--paddingX);
	cursor: pointer;
	display: flex;
	align-items: center;
	color: ${({ theme }) => theme.colors.richBlack} !important;
	gap: ${getCssSizeValue(8)};

	.icon {
		height: 21px;
		width: 21px;

		svg {
			path {
				fill: ${({ theme }) => theme.colors.richBlack} !important;
			}

			rect {
				stroke: ${({ theme }) => theme.colors.richBlack} !important;
			}
		}
	}
`

function getData(src) {
	return {
		header: src?.header || "",
		description: src?.description || "",
		isGoBackButtonVisible: src?.goBackButtonData?.visible,
		goBackButtonText: src?.goBackButtonData?.text || "",
		year: src?.goBackButtonData?.year || "",
		isSmallTextVariant: src?.smallTextVariant || false,
	}
}

export default function HeaderVariant({ data }) {
	const { header, description, isGoBackButtonVisible, goBackButtonText, year, isSmallTextVariant } = getData(data)

	return (
		<Wrapper>
			{isGoBackButtonVisible && (
				<StyledGoBackButton className="col-desktop-4" href={`/${PAGES.OTHERS}/${PAGES.ANNOUNCEMENTS_AND_TENDERS}/${year}`}>
					<Icon name={ICONS.ARROW_LEFT} />
					<div className="typo-strawford typo-strawford-79">{goBackButtonText}</div>
				</StyledGoBackButton>
			)}
			<GridContainer>
				<Reveal paused={false} className="col-mobile-8 col-tablet-5 col-desktop-12">
					<h1 className={`${isSmallTextVariant ? "typo-borna-116" : "typo-borna-120"} typo-borna header`}>
						{parseDatoText(header)}
					</h1>
				</Reveal>
			</GridContainer>
			{!isStringEmpty(description) && (
				<GridContainer>
					<Reveal paused={false} className="col-mobile-8 col-tablet-5 col-desktop-9">
						<div
							dangerouslySetInnerHTML={getHtmlFromRedactorField(description)}
							className={`typo-borna typo-borna-126 description`}
						/>
					</Reveal>
				</GridContainer>
			)}
		</Wrapper>
	)
}
